import { render } from "./AssignSubjects.vue?vue&type=template&id=7dffb1fa&scoped=true"
import script from "./AssignSubjects.vue?vue&type=script&lang=js"
export * from "./AssignSubjects.vue?vue&type=script&lang=js"

import "./AssignSubjects.vue?vue&type=style&index=0&id=7dffb1fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dffb1fa"]])

export default __exports__